import { graphql } from 'react-relay';

export const checkRefundHistory = graphql`
  query checkRefundHistoryQuery {
    bznavRefund {
      user {
        indis {
          __typename
        }
        corps {
          __typename
        }
        previousIndis {
          __typename
        }
        tritxIndis {
          __typename
        }
      }
    }
  }
`;
